import { Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { DefaultUserProfile } from '../../../../config/config';
import { Link } from 'react-router-dom';
import InstagramIcon1 from '../../../../components/icons/instagram-icon1';
import MaterialSymbol from '../../../../components/icons/material-symbol';
import dayjs from "dayjs";

type Props = {
  influencerData: any
  loading: boolean;
  email?: any;
  phone?: any;
  location?: any;
  category?: any;
  language?:any;
  subscription_status?:any;
}

const igFbPermissions = [
  "email",
  "pages_show_list",
  "public_profile",
  "instagram_basic",
  "pages_read_engagement",
  "instagram_manage_insights"
];

const igPermissions = [
  'instagram_business_basic',
  'instagram_business_manage_messages',
  'instagram_business_manage_comments'
];

const shouldShowPlatformDot = (row: any, permissions: string[]) => {
  return permissions.some(key => key in row && row[key] === "true");
};

const buildPlatformTooltipContent = (row: any, label: string, keys: string[]) => {
  return (
    <Stack spacing={0.75} style={{paddingLeft:'10px', paddingRight:'10px'}}>
      {/* Show Label First */}
      <span className="mt-1"></span>
      <Typography variant="caption" sx={{ mt: 1.5, mb: 0.5, pb:0.5, whiteSpace: 'pre-line' }}>
        {label} 
      </Typography>
      <hr/>
      <span className="mb-1"></span>

      {/* Then Show Permissions */}
      {keys.map((k) => (
        <Stack direction="row" alignItems="center" spacing={0.5} key={k} style={{paddingRight: '10px',paddingBottom:'2px'}}>
          {row[k] === "true" ? (
            <span className="dot-circle check me-1">
              <MaterialSymbol iconName="check" fontweight="400" />
            </span>
          ) : (
            <span className="dot-circle clear me-1">
              <MaterialSymbol iconName="clear" fontweight="400" />
            </span>
          )}
          <Typography style={{ fontSize: '12px', textTransform:'capitalize' }}>{k.replaceAll('_', ' ')}</Typography>
        </Stack>
      ))}
      <span className="mb-1"></span>
    </Stack>
  );
};


const InfluencerProfileLeftFB = ({ influencerData, email, phone, loading, location,language, category, subscription_status }: Props) => {
  const [showMoreText, setShowMoreText] = useState(false)
  const handleMoreText = () => {
    setShowMoreText((prev: boolean) => !prev)
  }
  const dob = influencerData?.detail?.[0]?.dob;
  const shouldRenderAge = dob && dob !== '1970-01-01';
  const influencerDetail = influencerData?.profile_detail || {};
  const normalizedUpdatedAt =
    influencerDetail?.timestamp ??
    influencerDetail?.profile_updated_at ??
    influencerDetail?.updated_at;
  return (
    <>
      {/* // FOR DESKTOP VIEW */}
      <div className='influencer-profile__left-inner d-none d-lg-flex'>
        <div className='influencer-profile__image'>
          <div
            className="text-muted"
            style={{
              position: "absolute",
              top: "5px",
              left: "5px",
              background: "rgba(255, 255, 255, 0.8)",
              padding: "2px 6px",
              borderRadius: "6px",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            Profile updated:&nbsp;
            {new Date(normalizedUpdatedAt).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </div>
          {loading ? <Skeleton width={132} height={132} variant='circular' /> : <img
            src={
              influencerDetail && (influencerDetail.gcp_page_logo ? influencerDetail.gcp_page_logo : 
                DefaultUserProfile?.influencer_unknown_default)
            }

            alt="Influencer Profile"
          />
          }
          <div className='influencer-profile__image--curve'></div>
          <div className='influencer-profile__image--curve-left'></div>
        </div>
        <div className='influencer-user__info'>
          {loading ? (
            <Skeleton height={57} />
          ) : (
            <h3>{influencerDetail?.page_name}</h3>
          )}
          <span className='fs-14'>
            {loading ? (
            <Skeleton style={{display:'inline-flex'}} width={20} height={20} />
          ) : influencerDetail?.age &&
              influencerDetail?.age !== '1970-01-01' && (
                <>
                  {influencerDetail?.age}
                  {influencerDetail?.gender !== 'Other' && influencerDetail?.age.trim() !== '' && ', '}
                </>
              )}

            {loading ? (
              <Skeleton width={50} style={{display:'inline-flex', marginLeft:
                '10px'
              }} />
            ) : (
              influencerDetail?.gender !== 'Other' &&
              influencerDetail?.gender
            )}
          </span>
        </div>
        
        <div className='influencer-user__location'>
          <div className='permission-dots ms-2 mb-3'>
          <div className='d-flex align-items-start' style={{marginBottom : loading ? "1rem" : "", alignItems : !loading ? "center" : ""}}>{loading ? <Skeleton height={12} variant='circular' width={12} style={{marginRight:
                '16px', }} /> : subscription_status.status && <span className='discover-dots'><Tooltip arrow 
          title={subscription_status.status == 'non_subscribed' ? 'Non - subscriber' : subscription_status.status == 'active' ? 'Active subscription' : 'Expired subscription'}>
            <span className={`discover_subscription_dot discover_subscription_dot_${subscription_status.status}`}></span></Tooltip></span>}
              {subscription_status.status && (
                <>
                  {/* IG-FB Dot */}
                  {influencerDetail.instagram_basic ? (
                    !loading ? (
                      shouldShowPlatformDot(influencerDetail, igFbPermissions) && (
                        <span className="discover-dots me-1">
                          <Tooltip
                            arrow
                            title={
                              <pre>
                                {buildPlatformTooltipContent(
                                  influencerDetail,
                                  'Instagram-Facebook\nToken: ' + (influencerDetail.token_status === 'Connected' ? 'Active' : influencerDetail.token_status),
                                  igFbPermissions
                                )}
                              </pre>
                            }
                          >
                            <span className="discover_subscription_dot discover_subscription_dot_igfb" />
                          </Tooltip>
                        </span>
                      )
                    ) : (
                      <Skeleton animation="wave" width={12} height={12} variant="circular" className="me-1" />
                    )
                  ) : null}

                  {/* IG Dot */}
                  {influencerDetail.instagram_business_basic ? (
                    !loading ? (
                      shouldShowPlatformDot(influencerDetail, igPermissions) && (
                        <span className="discover-dots me-1">
                          <Tooltip
                            arrow
                            title={
                              <pre>
                                {buildPlatformTooltipContent(
                                  influencerDetail,
                                  'Instagram\nToken: ' + (influencerDetail.ig_token_status === 'Connected' ? 'Active' : influencerDetail.ig_token_status),
                                  igPermissions
                                )}
                              </pre>
                            }
                          >
                            <span className="discover_subscription_dot discover_subscription_dot_ig" />
                          </Tooltip>
                        </span>
                      )
                    ) : (
                      <Skeleton animation="wave" width={12} height={12} variant="circular" className="me-1" />
                    )
                  ) : null}
                </>
              )}

          {
            loading ? <Skeleton height={21} width={150} /> : subscription_status.plan_start_date && 
            <p className='d-flex align-items-center'>
             
              <Tooltip arrow 
                   title='Plan date'><span>
                  {`${dayjs(subscription_status.plan_start_date).format('D MMM YYYY')} - ${dayjs(subscription_status.plan_end_date).format('D MMM YYYY')}`}
              </span></Tooltip>
            </p>
          }
          </div>
          </div>
          {(loading || (email && email.length > 0)) && <p className='d-flex align-items-center'>
            {loading ? <Skeleton width={20} height={24} /> : <MaterialSymbol iconName='mail' fontweight='200' color='#929292' iconFilled />} <span className='ms-2'>{loading ? <Skeleton width={150} height={24} />  : email}</span></p>}

            
          {(loading || (phone != 0 && phone)) && 
            <p className='d-flex align-items-center'>
              {loading ? <Skeleton width={20} height={24} /> : <MaterialSymbol iconName='call' fontweight='200' color='#929292' iconFilled />}
              <span className='ms-2'>{loading ? <Skeleton width={150} height={24} />  : phone}</span>
            </p>
          }
          {(loading || (location && location.length > 0)) && <p className='d-flex align-items-center'>{loading ? <Skeleton width={20} height={24} /> : <MaterialSymbol iconName='location_on' fontweight='200' color='#929292' iconFilled />}<span className='ms-2'>{loading ? <Skeleton width={150} height={24} />  : location}</span></p>}

          {influencerDetail?.current_city !== '' && (loading || influencerDetail?.current_city) &&
            <p className='d-flex align-items-center'>
              {loading ? <Skeleton width={20} height={24} /> : <MaterialSymbol iconName='home' fontweight='200' color='#929292' iconFilled />}
              <span className='ms-2'>{loading ? <Skeleton width={150} height={24} />  : influencerDetail?.current_city}</span>
            </p>
          }
          <div className='influencer-user__category'>
            {loading ? (
                <Skeleton height={26} width={50} />
              ) : (
                <span>{influencerDetail?.current_city}</span>
              )
            }
          </div>

          <div className='influencer-user__category'>
            {loading ? (
                <Skeleton height={26} width={50} />
              ) : (
                <span>{influencerDetail?.primary_category}</span>
              )
            }
          </div>



          {(loading || (language[0] || language[1] || language[2] || language[3])) &&
            <div className='influencer-user__category'>
              {loading ? <Skeleton height={26} width={50} /> :language[0] && <span>{language[0]}</span>}
              {loading ? <Skeleton height={26} width={50} /> :language[1] && <span>{language[1]}</span>}
              {loading ? <Skeleton height={26} width={50} /> :language[2] && <span>{language[2]}</span>}
              {loading ? <Skeleton height={26} width={50} /> :language[3] && <span>{language[3]}</span>}
            </div>
          }

        </div>
        <div className={`influencer-user__intro ${showMoreText ? "more-text" : ""}`}>
          <p className="mb-0">{loading ? <Skeleton height={72} /> : <>{influencerDetail?.summary_text}</>}</p>
          {loading ? <Skeleton height={24} /> : influencerDetail?.summary_text && influencerDetail?.summary_text.length > 85 && <button onClick={handleMoreText} className='btn btn-text-link'>{showMoreText ? "less" : "more"}</button>}
        </div>
      </div>

      {/* // FOR MOBILE VIEW */}
      <div className='influencer-profile__left-inner influencer-profile__left-inner-mobile d-lg-none'>
        <div className='influencer-user-profile'>
          <div className='influencer-profile__image influencer-user-profile-left'>
            {loading ? <Skeleton width={88} height={88} variant='circular' /> : <img className='d-flex'
              src={
                influencerData &&
                influencerData.profile_detail &&
                influencerData.profile_detail.length > 0
                && ((influencerData.profile_detail[0].gcp_profile_image_url ? influencerData.profile_detail[0].gcp_profile_image_url : influencerData.profile_detail[0].profile_image_url)
                  ||
                  DefaultUserProfile?.influencer_unknown_default)
              }

              alt="Influencer Profile"
            />
            }
             
          </div>
          
          <div className='influencer-user-profile-right d-flex d-lg-none flex-column align-items-start'>
            <h3>{loading ? <Skeleton width={200} /> : influencerData && influencerData?.profile_detail?.[0]?.insta_name}</h3>
            <div className='d-flex'>
              <InstagramIcon1 width="20px" height="20px" />
              <Link
                className="influencer-profile__social-chan"
                to={`https://www.instagram.com/${influencerData && influencerData?.profile_detail?.[0]?.username}`}
                target="_blank"
              >
                <span className="influ-prof-info-social-username d-flex justify-content-center align-items-baseline">
                  {loading ? <Skeleton width={150} /> : influencerData?.profile_detail?.[0]?.username}
                </span>
              </Link>
              </div>
               <div className='influencer-user__info'>
              
              
               {(loading || (email && email.length > 0)) && <p className='d-flex align-items-center mb-0 mb-lg-3'><MaterialSymbol iconName='mail' fontweight='200' color='#929292' iconFilled /> <span className='ms-lg-2'>{loading ? <Skeleton width={200} /> : email}</span></p>}
          {(loading || (phone != 0 && phone)) && 
            <p className='d-flex align-items-center mb-0 mb-lg-3'>
              <MaterialSymbol iconName='call' fontweight='200' color='#929292' iconFilled />
              <span className='ms-lg-2'>{loading ? <Skeleton width={200} /> : phone}</span>
            </p>
          }

          <Tooltip
                                            title={`Profile updated at ${new Date(influencerDetail.updated_at).toLocaleString('en-IN', {
                                              day: '2-digit',
                                              month: 'short',
                                              year: 'numeric',
                                            })}`}
                                            arrow
                                          >
                                            <span className="d-flex align-items-center mb-0" style={{ fontSize: '13px' }}>
                                              {new Date(influencerDetail.updated_at).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                              })}
                                            </span>
                                          </Tooltip>
            </div>
            
            </div>
           
       
        </div>
        <div className='' style={{borderTop:'1px solid #444', borderBottom:'1px solid #444', padding:'1rem 0'}}>
          <span className='fs-14'>
                  {loading ? <Skeleton width={50} /> : influencerData?.agegender_detail?.[0]?.age ? `${influencerData?.agegender_detail?.[0]?.age}, ` : "NA"}
                  <>{loading ? <Skeleton width={100} /> : influencerData?.agegender_detail?.[0]?.gender}</>
                </span>
          {(location && location.length > 0) && <p className='d-flex align-items-center mb-1 mb-lg-3'><MaterialSymbol className='d-none d-lg-flex' iconName='location_on' fontweight='200' color='#929292' iconFilled /><span className='ms-lg-1'>{loading ? <Skeleton width={200} /> : location}</span></p>}
          <div className='permission-dots d-flex align-items-center'   style={{ marginLeft: subscription_status?.plan_start_date ? '8px' : '0px' }}>
            {
              subscription_status.plan_start_date &&
              <p className='d-flex align-items-center mb-0 mb-lg-3' style={{marginLeft: "-6px"}}>
                <Tooltip arrow
                  title={subscription_status.status == 'non_subscribed' ? 'Non - subscriber' : subscription_status.status == 'active' ? 'Active subscription' : 'Expired subscription'}>
                  <span className={`discover_subscription_dot discover_subscription_dot_${subscription_status.status}`}></span></Tooltip>
                <MaterialSymbol iconName='workspace_premium' fontweight='200' color='#929292' iconFilled className='ms-2'/>
                <Tooltip arrow
                  title='Plan date'><span>
                    {loading ? <Skeleton /> : `${dayjs(subscription_status.plan_start_date).format('D MMM YYYY')} - ${dayjs(subscription_status.plan_end_date).format('D MMM YYYY')}`}
                  </span></Tooltip>
              </p>
            }
            {subscription_status.status && (
              <div className="d-flex align-items-center">
                {/* IG-FB Dot */}
                {influencerDetail.instagram_basic ? (
                  !loading ? (
                    shouldShowPlatformDot(influencerDetail, igFbPermissions) && (
                      <span className="position-relative discover-dots me-1">
                        <Tooltip
                          arrow
                          title={
                            <pre>
                              {buildPlatformTooltipContent(
                                influencerDetail,
                                'Instagram-Facebook\nToken: ' + (influencerDetail.token_status === 'Connected' ? 'Active' : influencerDetail.token_status),
                                igFbPermissions
                              )}
                            </pre>
                          }
                        >
                          <span className="discover_subscription_dot discover_subscription_dot_igfb" />
                        </Tooltip>
                      </span>
                    )
                  ) : (
                    <Skeleton animation="wave" width={12} height={12} variant="circular" className="me-1" />
                  )
                ) : null}

                {/* IG Dot */}
                {influencerDetail.instagram_business_basic ? (
                  !loading ? (
                    shouldShowPlatformDot(influencerDetail, igPermissions) && (
                      <span className="position-relative discover-dots me-1">
                        <Tooltip
                          arrow
                          title={
                            <pre>
                              {buildPlatformTooltipContent(
                                influencerDetail,
                                'Instagram\nToken: ' + (influencerDetail.ig_token_status === 'Connected' ? 'Active' : influencerDetail.ig_token_status),
                                igPermissions
                              )}
                            </pre>
                          }
                        >
                          <span className="discover_subscription_dot discover_subscription_dot_ig" />
                        </Tooltip>
                      </span>
                    )
                  ) : (
                    <Skeleton animation="wave" width={12} height={12} variant="circular" className="me-1" />
                  )
                ) : null}
              </div>
            )}
          </div>
        </div>
        <p className="mb-0">{loading ? <Skeleton /> : influencerData?.profile_detail?.[0]?.biography}</p>
        <div className='influencer-user__intro'>
             <div className='influencer-user-profile-right'>
            
            
            <div className='influencer-user__location'>
         
          
         
          
          {(loading || (category[0] || category[1] || category[2] || category[3])) &&
            <div className='influencer-user__category'>
              {(loading || category[0]) && <span>{loading ? <Skeleton /> : category[0]}</span>}
              {(loading || category[1]) && <span>{loading ? <Skeleton /> : category[1]}</span>}
              {(loading || category[2]) && <span>{loading ? <Skeleton /> : category[2]}</span>}
              {(loading || category[3]) && <span>{loading ? <Skeleton /> : category[3]}</span>}
            </div>
          }
          {(loading || (language[0] || language[1] || language[2] || language[3])) &&
            <div className='influencer-user__category'>
              {(loading || language[0]) && <span>{(loading ? <Skeleton /> : language[0])}</span>}
              {(loading || language[1]) && <span>{(loading ? <Skeleton /> : language[1])}</span>}
              {(loading || language[2]) && <span>{(loading ? <Skeleton /> : language[2])}</span>}
              {(loading || language[3]) && <span>{(loading ? <Skeleton /> : language[3])}</span>}
            </div>
          }

        </div>
          </div>
          
          
        </div>
      </div>
    </>
  )
}

export default InfluencerProfileLeftFB
